export enum TaxtSettingType {
  ALL = 1,
  BACKORDER_ITEM = 2,
  CATEGORY = 3,
  SHAPE = 4,
  DESIGNATE_INDUSTRY = 5,
  DESIGNATE_REGION = 6,
}
